// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import MassChannelCustomerFollowUpDealerCriteria from '../../../../src/reports/mass-channel-customer-follow-up/components/mass-channel-customer-follow-up-dealer-criteria';
import ReportCriteriaFooter from '../../shared/components/report-criteria-footer';

const MassChannelCustomerFollowUpCriteria = props =>
    <div className='mass-channel-customer-follow-up-criteria'>
        <div className='dealer-criteria'>
            <MassChannelCustomerFollowUpDealerCriteria
                allowedAccounts={props.allowedAccounts}
                onDealerSelect={props.onDealerSelect}
                onSelectAllDealers={props.onSelectAllDealers}
                selectedDealers={props.selectedDealers}
            />
        </div>
        <ReportCriteriaFooter
            canExport={props.canExport}
            canRunReport={props.canRunReport}
            isRequired={true}
            onCriteriaReset={props.onReset}
            onDownloadToExcel={props.onExportToCsv}
            onRunReport={props.onCreateReport}
            showExport={true}
            showReport={true}
        />
    </div>;

MassChannelCustomerFollowUpCriteria.displayName = 'MassChannelCustomerFollowUpCriteria';
MassChannelCustomerFollowUpCriteria.propTypes = {
    allowedAccounts: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired,
    canExport: PropTypes.bool.isRequired,
    canRunReport: PropTypes.bool.isRequired,
    onCreateReport: PropTypes.func.isRequired,
    onDealerSelect: PropTypes.func.isRequired,
    onExportToCsv: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
    onSelectAllDealers: PropTypes.func.isRequired,
    selectedDealers: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired
};

export default MassChannelCustomerFollowUpCriteria;



// WEBPACK FOOTER //
// ./src/reports/mass-channel-customer-follow-up/components/mass-channel-customer-follow-up-report-criteria.js